var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400", lazy: "" },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "title" }, [
            _vm._v(
              "\n      Attach " +
                _vm._s(_vm.$t("terms.bill-of-lading")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "px-3", attrs: { column: "" } },
            [
              _c(
                "v-layout",
                { staticClass: "pr-5", attrs: { column: "" } },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.immediate",
                        value: { required: true, alpha_dash: true },
                        expression: "{ required: true, alpha_dash: true }",
                        modifiers: { immediate: true }
                      }
                    ],
                    class: { "pb-2": _vm.errors.any() },
                    attrs: {
                      label: _vm.billOfLadingNumberFieldLabel,
                      "error-messages": _vm.errors.first("bolNumber"),
                      "data-vv-as": _vm.billOfLadingNumberFieldLabel,
                      "data-vv-name": "bolNumber"
                    },
                    model: {
                      value: _vm.billOfLadingNumber,
                      callback: function($$v) {
                        _vm.billOfLadingNumber = $$v
                      },
                      expression: "billOfLadingNumber"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.openDialog
                ? _c("files-upload-btn", {
                    attrs: {
                      "btn-class": "primary mx-0",
                      "uploading-progress": _vm.uploadPercentage,
                      multiple: "",
                      disabled: _vm.errors.any()
                    },
                    on: {
                      upload: function($event) {
                        return _vm.uploadBOL($event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", color: "accent" },
                  on: {
                    click: function($event) {
                      _vm.openDialog = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e080183", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e080183","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/UploadBillofLadingDialog.vue
// module id = null
// module chunks = 